import React, { useState } from 'react'
import { observer } from 'mobx-react-lite'
import { useRouteMatch } from 'react-router-dom'

import { TableHelper } from '../../../../tables'
import { AssignmentTable } from '../../../../tables/assignment-table'

const Assignments = observer(() => {
  const match = useRouteMatch<any>('/content/paths/:id/assignments')
  const pathID = Number(match?.params?.id)

  const [tableHelper] = useState(
    new TableHelper('list_path_assignments', 'assignments', 'paths', pathID, 'active'),
  )

  return <AssignmentTable filter="active" tableHelper={tableHelper} />
})

export const PathAssignmentsTab = (props: any) => {
  const { id } = props
  return {
    name: 'Assignments',
    path: `/content/paths/${id}/assignments`,
    component: () => <Assignments />,
  }
}
